import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  BrowserRouter as Router
} from "react-router-dom";
import { ChakraProvider } from '@chakra-ui/react';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { msalConfig } from './authConfig';
import theme from './_sys/theme';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';


const msalInstance = new PublicClientApplication(msalConfig);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});


const container = document.getElementById('root');
const root = createRoot(container);

root.render(<React.StrictMode>
  <MsalProvider instance={msalInstance}>
    <QueryClientProvider client={queryClient}>
      <Router>
        <ChakraProvider theme={theme}>
          <ErrorBoundary>
          <App />
          </ErrorBoundary>
        </ChakraProvider>
      </Router>
      <ReactQueryDevtools position="bottom-left" />
    </QueryClientProvider>
  </MsalProvider>
</React.StrictMode>);
